import {
  StorageConfigBody,
  StorageConfigResponse,
  StorageInfoResponse,
} from '@models/utilities';
import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';

const getUtilitiesApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/utilities/storage`;
};

export const getStorage = async ({ accessToken }: { accessToken: string }) => {
  const Storage_URL = await getUtilitiesApi();

  const response: AxiosResponse<StorageInfoResponse> = await axios
    .get(`${Storage_URL}`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const getStorageConfig = async ({
  accessToken,
}: {
  accessToken: string;
}) => {
  const Storage_URL = await getUtilitiesApi();

  const response: AxiosResponse<StorageConfigResponse> = await axios
    .get(`${Storage_URL}/config`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const patchStorageConfig = async ({
  accessToken,
  params,
}: {
  accessToken: string;
  params: StorageConfigBody;
}) => {
  const Storage_URL = await getUtilitiesApi();
  const response: AxiosResponse = await axios
    .patch(Storage_URL, params, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};
